const closePerPageMenu = (root) => {
  const trigger = root.querySelector("[data-participants-per-page-trigger]")
  const menu = root.querySelector("[data-participants-per-page-menu]")
  if (!trigger || !menu) return

  menu.hidden = true
  trigger.setAttribute("aria-expanded", "false")
  trigger.classList.remove("is-open")
}

const openPerPageMenu = (root) => {
  const trigger = root.querySelector("[data-participants-per-page-trigger]")
  const menu = root.querySelector("[data-participants-per-page-menu]")
  if (!trigger || !menu) return

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")
}

const submitPerPageForm = (form) => {
  if (typeof form.requestSubmit === "function") {
    form.requestSubmit()
  } else {
    form.submit()
  }
}

const bindPerPageDropdown = (form) => {
  if (form.dataset.perPageBound === "true") return
  form.dataset.perPageBound = "true"

  const root = form.querySelector("[data-participants-per-page-dropdown]")
  const trigger = root?.querySelector("[data-participants-per-page-trigger]")
  const menu = root?.querySelector("[data-participants-per-page-menu]")
  const field = form.querySelector("[data-participants-per-page-field]")
  const valueLabel = form.querySelector("[data-participants-per-page-value]")
  if (!root || !trigger || !menu || !field) return

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (menu.hidden) {
      openPerPageMenu(root)
    } else {
      closePerPageMenu(root)
    }
  })

  menu.addEventListener("click", (event) => {
    event.stopPropagation()
  })

  menu.querySelectorAll("[data-participants-per-page-option]").forEach((option) => {
    option.addEventListener("click", (event) => {
      event.preventDefault()
      const value = option.dataset.value
      if (!value || field.value === value) {
        closePerPageMenu(root)
        return
      }

      field.value = value
      if (valueLabel) valueLabel.textContent = value
      menu.querySelectorAll("[data-participants-per-page-option]").forEach((item) => {
        const active = item === option
        item.classList.toggle("is-active", active)
        item.setAttribute("aria-selected", active ? "true" : "false")
      })
      closePerPageMenu(root)
      submitPerPageForm(form)
    })
  })
}

const initBackofficeParticipantsPerPage = () => {
  document.querySelectorAll("form[data-participants-per-page]").forEach(bindPerPageDropdown)
}

document.addEventListener("click", () => {
  document.querySelectorAll("[data-participants-per-page-dropdown]").forEach(closePerPageMenu)
})

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("form[data-participants-per-page]").forEach((form) => {
    const root = form.querySelector("[data-participants-per-page-dropdown]")
    if (root) closePerPageMenu(root)
    form.dataset.perPageBound = "false"
  })
})

export { initBackofficeParticipantsPerPage }
